export default function Plus() {
  return (
    <svg
      width='34'
      height='34'
      viewBox='0 0 34 34'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <rect
        y='16.9707'
        width='24'
        height='24'
        rx='12'
        transform='rotate(-45 0 16.9707)'
        fill='#222222'
      />
      <path
        d='M17.1162 24.0957L16.8151 9.85066'
        stroke='white'
        strokeWidth='1.39007'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.84863 17.1245L16.9712 16.9739L24.0937 16.8234'
        stroke='white'
        strokeWidth='1.39007'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
